import { SAMPLE_STOCK_IN_REQUESTS } from "@/features/consignment-stock-in-request/data/stockInRequestFixtures";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Old path: keep links working.
export const Route = createFileRoute("/vendor/stock-in/$stockInId")({
	beforeLoad: ({ params }) => {
		const requestRecord = SAMPLE_STOCK_IN_REQUESTS.find(
			(candidate) => candidate.stockInRequestNumber === params.stockInId,
		);
		if (!requestRecord)
			throw redirect({
				to: "/vendor/consignment-stock-in-request",
				search: true,
				replace: true,
			});
		throw redirect({
			to: "/vendor/consignment-stock-in-request/$id/detail",
			params: { id: requestRecord.stockInRequestId },
			search: true,
			replace: true,
		});
	},
});
